export const PROJECTS_TABLES_CONFIG = {
  TREE: {
    id: () => "TREE",
    preferencesId: "PROJECT_TREE",
  },
};
